import React from 'react'
import { Outlet } from 'react-router-dom'

const UserPage = () => {
  return (
    <Outlet />
  )
}

export default UserPage